module.exports = __webpack_public_path__ + "images/data-science-fundamentals.png";